import request from '@/utils/request'
import moment from 'moment'

export function fetchList (data) {
  return request({
    url: '/post/ListByOrg',
    method: 'post',
    data
  })
}

export function getItem (id) {
  return request({
    url: '/post/GetPostInfo',
    method: 'get',
    params: { id: id }
  })
}

export function listCategory () {
  return request({
    url: '/post/ListCategory',
    method: 'post',
    data: {}
  })
}

export function createItem (data) {
  // console.log('createItem', data)
  data.post_date = moment(data.post_date).utc().format()
  // console.log('createItem post_date utc', data)
  return request({
    url: '/post/Create',
    method: 'post',
    data
  })
}

export function updateItem (data) {
  // console.log('updateItem', data)
  data.post_date = moment(data.post_date).utc().format()
  return request({
    url: '/post/Update',
    method: 'post',
    data
  })
}

export function deleteItem (data) {
  console.log('deleteItem', data)
  return request({
    url: '/post/Delete',
    method: 'delete',
    data
  })
}

export function profileCompleted () {
  return request({
    url: '/post/ProfileCompleted',
    method: 'get'
  })
}
